import styled, { css } from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $isActiveContract: boolean }>`
	${({ $isActiveContract }) =>
		$isActiveContract &&
		css`
			display: grid;
			grid-template-columns: 430px 1fr;
		`}
`;

const StyledLeftContainer = styled.div<{ $isActiveContract: boolean }>`
	padding: ${({ $isActiveContract }) =>
		$isActiveContract ? '20px 30px 0 20px' : '20px'};
	border-right: ${({ $isActiveContract }) =>
		$isActiveContract ? '1px solid rgba(255, 255, 255, 0.1)' : 'none'};
`;

const StyledHeadTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: #1ab248;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledHeaderTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledActiveOrderContainer = styled.div`
	margin-top: 20px;
`;

const StyledInfoContainer = styled.div`
	height: 100%;
	padding-top: 17px;
`;

const StyledProgressContainer = styled.div`
	margin-top: 10px;
	display: grid;
	align-items: center;
	grid-template-columns: 82px 2px 138px 2px 1fr auto;
	gap: 20px;
	height: 70px;
	padding: 0 20px;
	background: rgba(26, 178, 72, 0.1);
	border: 1px solid rgba(26, 178, 72, 0.1);
	border-radius: 10px;

	.dividers {
		display: flex;

		${Divider} {
			height: 30px;
		}
	}
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 30px;
	padding: 0 8px;
	background-color: #ffffff;
	border-radius: 10px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #262628;
	}

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		filter: invert(1);
	}
`;

const StyledRubleGreen = styled.div`
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	width: 10px;
	height: 10px;
	background-color: #1ab248;
`;

const StyledPriceExpContainer = styled.div`
	display: flex;
	align-items: center;
	margin-top: 6px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
	}
`;

const StyledStatusContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledStatus = styled.div<{ $isActive: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 5px;
	height: 20px;
	border-radius: 5px;
	background-color: ${({ $isActive }) =>
		$isActive ? 'rgba(26, 178, 72, 0.1)' : 'rgba(255, 255, 255, 0.1)'};

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: ${({ $isActive }) => ($isActive ? '#1AB248' : '#ffffff')};
	}
`;

const StyledStatusProgressSvg = styled.svg`
	width: 30px;
	height: 30px;

	.indicator {
		transform-origin: center;
		transform: rotate(90deg);
	}
`;

const StyledOrdersContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow-y: auto;
	padding-bottom: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledAllContractsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 20px;
	height: 379px;
	overflow-y: scroll;
	padding-bottom: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledNotActiveContactHeading = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledActiveContractHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledActiveContractHeadingLeft = styled(Text)`
	font-size: 16px;
	color: rgba(255, 255, 255, 0.25);

	span {
		font-weight: 500;
		color: #fabe2c;
	}
`;

const StyledRightContainer = styled.div`
	padding: 20px;
	height: 100%;
`;

export {
	StyledActiveContractHeadingContainer,
	StyledActiveContractHeadingLeft,
	StyledActiveOrderContainer,
	StyledAllContractsContainer,
	StyledContainer,
	StyledHeader,
	StyledHeaderTitle,
	StyledHeadTitleContainer,
	StyledInfoContainer,
	StyledLeftContainer,
	StyledNotActiveContactHeading,
	StyledOrdersContainer,
	StyledPriceExpContainer,
	StyledProgressContainer,
	StyledRightContainer,
	StyledRubleGreen,
	StyledStatus,
	StyledStatusContainer,
	StyledStatusProgressSvg,
	StyledTimerContainer,
};
